import React from 'react';
import AttachmentContent from "./attachment-content.jsx";
import ImageReservationContent from "./image-reservation-content.jsx";
import DisplacementContent from "./displacement-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import GarrisonFiscalizationContent from "./garrison-fiscalization-content.jsx";
import {buildAttachmentRows, GARRISON_FISCALIZATION_FIELD, isAttachmentField, isIgnoredInlineField, parseAuditJson} from "../utils/dispatch-audit-utils.js";

const CreateContent = ({element}) => {
    const createData = parseAuditJson(element?.new);

    return (
        <tr className="create-content-table">
            <td colSpan={14} className={'bg-white!'}>
                <table className="applied insider w-full">
                    <thead>
                        <tr className='text-left'>
                            <th style={{width: "30%"}}>Campo</th>
                            <th style={{width: "70%"}}>Novo</th>
                        </tr>
                    </thead>

                    <tbody>

                    {Object.entries(createData).map(([key, value], index) => {
                        if (isIgnoredInlineField(key)) return null;

                        if (isAttachmentField(key)) {
                            const attachments = buildAttachmentRows(value);
                            if (attachments.length === 0) return null;

                            return (
                                <AttachmentContent key={index} attachments={attachments}/>
                            );
                        }

                        return (
                            <tr key={index} className="text-left">
                                <td>{key}</td>
                                <td className={'break-all! whitespace-normal'}>{ReportUtils.formatObjectString(value)}</td>
                            </tr>
                        );
                    })}

                    { createData[GARRISON_FISCALIZATION_FIELD] && (
                        <GarrisonFiscalizationContent garrison={createData[GARRISON_FISCALIZATION_FIELD]}/>
                    )}

                    { createData.dispatch_displacement && (
                        <DisplacementContent displacements={createData.dispatch_displacement}/>
                    )}

                    { createData["image-reservation"] && (
                        <ImageReservationContent reservation={createData["image-reservation"]}/>
                    )}

                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default CreateContent;